import { Form, FormikProps, FormikValues } from "formik";
import React, { PropsWithChildren, useEffect, useState } from "react";

import { IM365PulseFormProps } from "./M365PulseForm.types";
import { observer } from "mobx-react";
import { useM365PulseFormChildrenWrapperStyles } from "./M365PulseFormChildrenWrapper.styles";

const M365PulseFormChildrenBase = <Values extends FormikValues = FormikValues>(
    props: PropsWithChildren<
        FormikProps<Values> & {
            onValuesChange?: IM365PulseFormProps<Values>["onValuesChange"];
        }
    >
) => {
    const { values, onValuesChange } = props;
    const classes = useM365PulseFormChildrenWrapperStyles();

    const [valuesSnapshot, setValuesSnapshot] = useState(props.initialValues);

    useEffect(() => {
        if (onValuesChange) {
            const changedFieldName = Object.keys(values).find((key) => values[key] !== valuesSnapshot[key]);
            onValuesChange(
                values,
                {
                    setFieldValue: props.setFieldValue,
                    setFieldError: props.setFieldError,
                    setValues: props.setValues
                },
                changedFieldName
            );
        }
        setValuesSnapshot(values);

        // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when values change
    }, [values]);

    return <Form className={classes.root}>{props.children}</Form>;
};

export const M365PulseFormChildrenWrapper = observer(M365PulseFormChildrenBase);
